module.exports = __webpack_public_path__ + "img/whatsapp_colors.7dc3f32.svg";